import { render, staticRenderFns } from "./emailSettings.vue?vue&type=template&id=6581f2c7&scoped=true"
import script from "./emailSettings.vue?vue&type=script&lang=js"
export * from "./emailSettings.vue?vue&type=script&lang=js"
import style0 from "./emailSettings.vue?vue&type=style&index=0&id=6581f2c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581f2c7",
  null
  
)

export default component.exports